import React from "react";
import { Row, Col, Tooltip } from "antd";
import { Info } from "@material-ui/icons";
import { UPLOAD_TYPE } from "../uploadTypeEnum";

const exampleCSV = `site,year,month,Grand_begin_index,Grand_end_index,ON_begin_index,OFF_begin_index,ON_end_index,OFF_end_index
makro_chumphon,2026,03,1000,2000,,,,
edmi_site_example,2026,03,,,500,300,1500,800`;

const downloadExampleCSV = () => {
  const blob = new Blob([exampleCSV], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "example_monthly_indexes.csv";
  a.click();
  URL.revokeObjectURL(url);
};

export const updateIndexesCSVUploadConfig = {
  modal: {
    title: () => (
      <>
        Monthly Indexes CSV Format{"  "}
        <Tooltip
          overlayClassName="custom-tooltip-wide"
          title={
            <>
              <p className="custom-small-font" style={{ textIndent: "2em" }}>
                The CSV file must contain the following columns:
              </p>
              <ul className="custom-small-font">
                <li><b>site</b> — Site table_name</li>
                <li><b>year</b> — Year (YYYY, cannot be in the future)</li>
                <li><b>month</b> — Month (MM or M, cannot be in the future)</li>
              </ul>
              <p className="custom-small-font" style={{ textIndent: "2em" }}>
                For <b>non-EDMI</b> (GRP) sites:
              </p>
              <ul className="custom-small-font">
                <li><b>Grand_begin_index</b> — Start index (comma-separated if multiple injection points)</li>
                <li><b>Grand_end_index</b> — End index (comma-separated if multiple injection points)</li>
              </ul>
              <p className="custom-small-font" style={{ textIndent: "2em" }}>
                For <b>EDMI</b> sites:
              </p>
              <ul className="custom-small-font">
                <li><b>ON_begin_index</b> — ON start index</li>
                <li><b>OFF_begin_index</b> — OFF start index</li>
                <li><b>ON_end_index</b> — ON end index</li>
                <li><b>OFF_end_index</b> — OFF end index</li>
              </ul>
              <p className="custom-small-font" style={{ color: "#888" }}>
                Comma-separated values count must match the site's injection points.
              </p>
            </>
          }
          placement="bottom"
        >
          <Info />
        </Tooltip>
      </>
    ),
    content: () => (
      <>
        <Row>
          <Col span={24}>
            <p className="custom-medium-font" style={{ textIndent: "2em" }}>
              Upload a CSV to update monthly indexes. The backend determines
              whether the site uses EDMI or GRP meters and applies the correct
              columns. Non-EDMI Grand columns are mapped to ON columns for the
              PHP endpoint. Injection point count is validated.
            </p>
          </Col>
        </Row>
        <Row style={{ marginTop: "15px" }}>
          <Col span={24}>
            <p className="custom-medium-font"><b>Example CSV:</b></p>
            <pre style={{ background: "#f5f5f5", padding: "10px", fontSize: "12px", overflowX: "auto" }}>
{exampleCSV}
            </pre>
            <p className="custom-small-font" style={{ color: "#888", marginTop: "5px" }}>
              Row 1: non-EDMI site (uses Grand columns). Row 2: EDMI site (uses ON/OFF columns).
            </p>
          </Col>
        </Row>
        <Row style={{ marginTop: "10px" }}>
          <Col span={24}>
            <button className="btn btn-default btn-sm" onClick={downloadExampleCSV}>
              Download Example CSV
            </button>
          </Col>
        </Row>
      </>
    ),
  },
  form: {
    title: UPLOAD_TYPE.INDEXES,
    description: "Upload a CSV to update monthly indexes (EDMI ON/OFF or GRP) for sites.",
    upload: {
      uploadUrl: "/daily/upload_update_indexes",
      maxCount: 1,
      accept: ".csv",
      isInvalid: (file) => {
        const fileName = file.name.toLowerCase();
        if (!fileName.endsWith(".csv")) return "You can only upload CSV files!";
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isLt5M) return "File must be smaller than 5MB!";
      },
    },
  },
};
